// extracted by mini-css-extract-plugin
module.exports = {"v-application":"ConfirmDialog_v-application_2pVlD","text-h1":"ConfirmDialog_text-h1_15Vzd","text-h2":"ConfirmDialog_text-h2_1bwcw","text":"ConfirmDialog_text_NWijx"};